/****************************************************
 * Module Name:  customerProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class CustomerProxy {
  static GetAllCustomerDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/customer/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleEmployeesCustomerById = (employeeid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/employee/${employeeid}/customer/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleCustomerById = (customerid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/customer/${customerid}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateCustomer = (customerid, customerData, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/customer/${customerid}/detail`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(customerData),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
